import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { Link } from 'src/common/styled';
import { TaxBreakdownModal } from './TaxBreakdownModal';
export const TaxBreakdown = ({ taxSummary }) => {
    var _a, _b, _c;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const onTaxDetailsClick = () => {
        setIsModalOpen(true);
    };
    const onCloseModal = () => {
        setIsModalOpen(false);
    };
    if (!((_b = (_a = taxSummary === null || taxSummary === void 0 ? void 0 : taxSummary.message) === null || _a === void 0 ? void 0 : _a.fragments) === null || _b === void 0 ? void 0 : _b.length) || !((_c = taxSummary === null || taxSummary === void 0 ? void 0 : taxSummary.items) === null || _c === void 0 ? void 0 : _c.length))
        return null;
    const fragments = taxSummary.message.fragments;
    return (_jsxs(_Fragment, { children: [_jsx(Row, { spacingInset: "400 350", spacing: "300", alignmentVertical: "stretch", "data-testid": "tax-summary-block", children: _jsx(Column, { spacingInset: "none", spacing: "300", children: _jsx(Text, { type: "b200", children: fragments.map((fragment, index) => {
                            var _a, _b;
                            return (_jsxs("span", { children: [fragment.text, ((_b = (_a = fragment.link) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.text) && (_jsx(_Fragment, { children: _jsx(Link, { role: "button", onClick: onTaxDetailsClick, "data-testid": "tax-details-link", children: fragment.link.content.text }) }))] }, index));
                        }) }) }) }), _jsx(TaxBreakdownModal, { isOpen: isModalOpen, onClose: onCloseModal, taxSummary: taxSummary })] }));
};
